import React from "react";

import InfoItem from "components/InfoItem";

import { formatIban } from "shared/functions/formatIban";

import { IbanInvoiceResponseDto } from "api";

interface AccountInfoProps {
  iban: IbanInvoiceResponseDto | null;
  copyEnabled?: boolean;
}

const AccountInfo: React.FC<AccountInfoProps> = (props) => {
  const { iban, copyEnabled } = props;

  return (
    <>
      <InfoItem
        id="organization_name"
        title="Юридична назва компанії або ФОП"
        value={iban?.organizationName || ""}
        copyEnabled={copyEnabled}
      />
      <InfoItem
        id="identificatio_code"
        title="ЄДРПОУ / РНОКПП"
        value={iban?.identificationCode || ""}
        copyEnabled={copyEnabled}
      />
      <InfoItem
        id="iban"
        title="IBAN"
        value={iban?.iban ? formatIban(iban.iban) : ""}
        subtitle={
          typeof iban?.bank === "string" ? iban?.bank : iban?.bank?.name || ""
        }
        copyEnabled={copyEnabled}
        copyWithoutSpaces
      />
      <InfoItem
        id="payment_purpose"
        title="Призначення платежу"
        value={iban?.paymentPurpose || ""}
        expandValue={(iban?.paymentPurpose || "").length > 35}
        copyEnabled={copyEnabled}
      />
    </>
  );
};

export default AccountInfo;
